import BillingsOrderCargoRailyRecalculateRequest, {
  BillingsOrderCargoRailyRecalculateRequestBody,
} from "./billings-order-cargo-raily-recalculate.request";

const create = (
  request: BillingsOrderCargoRailyRecalculateRequest,
): BillingsOrderCargoRailyRecalculateRequestBody => {
  return {
    billingNodes: request.billingNodes,
    discount: request.discount,
  };
};

const billingsOrderCargoRailyRecalculateRequestFactory = { create };

export default billingsOrderCargoRailyRecalculateRequestFactory;
